import { memo, PropsWithChildren } from 'react';
import { MenuTrigger } from 'react-aria-components';

import { Menu, MenuItem, Popover, Text } from '@/components/core';
import { CSVIcon, JSONIcon } from '@/components/icons';
import { useCreateCSVExport, useCreateJSONExport, useDownloadFile } from '@/hooks';

export type ExportMenuProps = PropsWithChildren<{
  agentId?: string | null;
  runIds?: string[] | null;
}>;

const IExportMenu = ({ agentId, runIds, children }: ExportMenuProps) => {
  const { create: createCSV } = useCreateCSVExport({ agentId, runIds });
  const { create: createJSON } = useCreateJSONExport({ agentId, runIds });
  const { download: downloadCSV } = useDownloadFile({ fetchData: createCSV, downloadedFileName: 'export.csv' });
  const { download: downloadJSON } = useDownloadFile({ fetchData: createJSON, downloadedFileName: 'export.json' });

  return (
    <MenuTrigger>
      {children}

      <Popover placement="top">
        <Menu>
          <MenuItem onAction={downloadCSV}>
            <CSVIcon />
            <Text>Export as CSV</Text>
          </MenuItem>
          <MenuItem onAction={downloadJSON}>
            <JSONIcon />
            <Text>Export as JSON</Text>
          </MenuItem>
        </Menu>
      </Popover>
    </MenuTrigger>
  );
};

export const ExportMenu = memo(IExportMenu) as typeof IExportMenu;
